type DomainName = `@${string}`;

export const ALLOWED_MAIL_DOMAIN_NAME_LIST: readonly DomainName[] = [
  "balus.co",
  "bita.jp",
  "testmail.autify.com",
].reduce<readonly DomainName[]>((previousValue, currentValue) => {
  // 大文字が使える環境向けに小文字で統一
  const normalizedDomain = currentValue.toLowerCase();
  return [...previousValue, `@${normalizedDomain}`];
}, []);
